import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import { BatchLogRecordProcessor, ConsoleLogRecordExporter, LoggerProvider, SimpleLogRecordProcessor } from '@opentelemetry/sdk-logs';
import { logs } from '@opentelemetry/api-logs';

const isDev = process.env.DEV !== 'false';
const baseUrl = process.env.OTEL_EXPORTER_OTLP_ENDPOINT;

const loggerProvider = new LoggerProvider({
  processors: [
    isDev
      ? new SimpleLogRecordProcessor(new ConsoleLogRecordExporter())
      : new BatchLogRecordProcessor(
        new OTLPLogExporter({ url: `${baseUrl}/v1/logs` }),
        { maxQueueSize: 100, maxExportBatchSize: 10, scheduledDelayMillis: 500 }
      ),
  ],
});
logs.setGlobalLoggerProvider(loggerProvider);

export const logger = logs.getLogger('bbm-jornal');
